export default function CTASection() {
  return (
    <section className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20sunlit%20interior%20with%20minimal%20wooden%20shelf%20displaying%20neatly%20folded%20knitwear%20and%20ceramic%20vase%2C%20cozy%20Scandinavian%20aesthetic%2C%20natural%20daylight%20pouring%20through%20large%20window%2C%20soft%20beige%20and%20oatmeal%20color%20palette%2C%20calm%20serene%20atmosphere%2C%20elevated%20interior%20photography&width=1920&height=1080&seq=cta-bg-v2&orientation=landscape"
          alt="ACBuy Spreadsheet shopping experience"
          title="ACBuy Spreadsheet - Start Shopping Smarter"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 text-center">
        <div className="animate-fade-in-up">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white tracking-wide leading-none mb-6">
            ACBUY SPREADSHEET
          </h2>
          <p className="text-base md:text-xl text-white/80 font-light max-w-xl mx-auto leading-relaxed mb-3">
            Start using the acbuy spreadsheet today and discover better products in less time.
          </p>
          <p className="text-sm text-white/55 max-w-lg mx-auto leading-relaxed mb-12">
            Thousands of savvy shoppers rely on the <strong className="text-white/85 font-semibold">acbuyspreadsheet</strong> system
            as their centralized shopping intelligence tool. Join them now.
          </p>
        </div>

        {/* Special Pill Button */}
        <div className="animate-fade-in-up-delay-1 inline-flex">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-0 px-2 py-2 pr-7 rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-all duration-300 hover:scale-105 group cursor-pointer"
          >
            <span className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center mr-3">
              <i className="ri-shopping-bag-line text-white text-xl"></i>
            </span>
            <span className="text-base font-bold tracking-wide uppercase whitespace-nowrap">Buy It Now</span>
            <i className="ri-arrow-right-up-line text-lg ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}